import { useSyncExternalStore } from 'react';

import { isVisualRefreshEnabled } from '../utils/is-visual-refresh-enabled.js';

/**
 * @internal
 */
export function useVisualRefreshEnabled(): boolean {
  return useSyncExternalStore(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    () => () => (globalThis as any).dtVisualRefreshEnabled,
    () => isVisualRefreshEnabled(),
    () => false,
  );
}
